import type { ReactNode } from 'react';
import { useRouter } from './router.js';
import { Icon, RouteIcon } from './icons.js';

/**
 * Consistent screen header: an accent icon tile, title, optional subtitle, and
 * right-aligned actions. Uses the current route's icon unless one is given.
 */
export function ScreenHeader({
  title,
  subtitle,
  actions,
  icon,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  icon?: string;
}) {
  const { path } = useRouter();
  return (
    <div className="page-head">
      <div style={{ display: 'flex', gap: 14, alignItems: 'center', minWidth: 0 }}>
        <span className="screen-head__icon">
          {icon ? <Icon name={icon} size={22} /> : <RouteIcon route={path} size={22} />}
        </span>
        <div style={{ minWidth: 0 }}>
          <h1 className="page-title">{title}</h1>
          {subtitle ? <div className="page-sub">{subtitle}</div> : null}
        </div>
      </div>
      {actions ? <div className="lc-row__meta">{actions}</div> : null}
    </div>
  );
}
